import moment from 'moment';
import { customAxios, IDUSUARIO, ENTREGAS_URL } from '../constants';

export function createLugarDespacho(codFilial, codFamilia, cantMax, codTipo) {
  const config = {
    headers: {
      idUsuario: IDUSUARIO,
    },
  };

  const data = {
    canMaxiUnid: cantMax,
    codFamiliaVehi: codFamilia,
    codFilial,
    codTipoDia: codTipo,
    indInactivo: 'N',
  };

  return customAxios.post(`${ENTREGAS_URL}/entrega-vehiculo-maestro/lugares-despacho`, data, config);
}

export function editLugarDespacho(codFilial, codFamilia, cantMax, codTipo, activo, lugar) {
  const config = {
    headers: {
      idUsuario: IDUSUARIO,
    },
  };

  const data = {
    canMaxiUnid: cantMax,
    codFamiliaVehi: codFamilia,
    codFilial,
    codTipoDia: codTipo,
    indInactivo: activo ? 'N' : 'S',
  };

  return customAxios.put(`${ENTREGAS_URL}/entrega-vehiculo-maestro/lugares-despacho/${lugar}`, data, config);
}

export function createLugarEntrega(values) {
  const config = {
    headers: {
      idUsuario: IDUSUARIO,
    },
  };

  const data = {
    canMaxiUni: values.unidadMaxFormulario,
    cantVehParalelo: values.indParalelo ? values.cantidadParalelo : 1,
    codFamVeh: values.familiaFormulario,
    codFilial: values.filialFormulario,
    codTipoDia: values.unidadesFormulario,
    codUsuaModi: '',
    codUsuarioCrea: IDUSUARIO,
    fecModiReg: '',
    horaIniLocked: values.horaInicioBloqueo ? `24/10/2017 ${values.horaInicioBloqueo}:00` : '',
    horaFinLocked: values.horaFinBloqueo ? `24/10/2017 ${values.horaFinBloqueo}:00` : '',
    horaIniEntr: values.horaInicio ? `24/10/2017 ${values.horaInicio}:00` : '',
    horaMaxEntr: values.horaInicioMax ? `24/10/2017 ${values.horaInicioMax}:00` : '',
    indFlota: values.flota ? 'S' : 'N',
    indInactivo: 'N',
    indParalelo: values.indParalelo ? 'S' : 'N',
    numHorasReservada: values.horasReservadas,
    tipoUnidad: '',
    desFamVeh: '',
    nomFilial: '',
    indSabado: values.indSabado? 'S' : 'N',   
    indDomingo:values.indDomingo? 'S' : 'N',
  };

  return customAxios.post(`${ENTREGAS_URL}/entrega-vehiculo-maestro/lugares-entrega`, data, config);
}

export function editLugarEntrega(values, lugar) {
  const config = {
    headers: {
      idUsuario: IDUSUARIO,
    },
  };

  const data = {
    canMaxiUni: values.unidadMaxFormulario,
    cantVehParalelo: values.indParalelo ? values.cantidadParalelo : 1,
    codFamVeh: values.familiaFormulario,
    codFilial: values.filialFormulario,
    codTipoDia: values.unidadesFormulario,
    horaIniLocked: values.horaInicioBloqueo ? `24/10/2017 ${values.horaInicioBloqueo}:00` : '',
    horaFinLocked: values.horaFinBloqueo ? `24/10/2017 ${values.horaFinBloqueo}:00` : '',
    horaIniEntr: values.horaInicio ? `24/10/2017 ${values.horaInicio}:00` : '',
    horaMaxEntr: values.horaInicioMax ? `24/10/2017 ${values.horaInicioMax}:00` : '',
    indFlota: values.flota ? 'S' : 'N',
    indInactivo: values.indInactivo ? 'N' : 'S',
    indParalelo: values.indParalelo ? 'S' : 'N',
    indSabado: values.indSabado? 'S' : 'N',   
    indDomingo:values.indDomingo? 'S' : 'N',
    numHorasReservada: values.horasReservadas,
    tipoUnidad: '',
    desFamVeh: '',
    nomFilial: '',
    codUsuaModi: '',
    fecModiReg: '',
  };

  return customAxios.put(`${ENTREGAS_URL}/entrega-vehiculo-maestro/lugares-entrega/${lugar}`, data, config);
}

export function createDiasTraslado(values) {

  console.log(values);

  const config = {
    headers: {
      idUsuario: IDUSUARIO,
    },
  };

  const data = {
    canDias: values.canDias,
    codSucuDest: values.sucEntrega,
    codSucuOrig: values.sucDespacho,
    codFamilia: values.familia,
    indInactivo: 'N',
  };

  return customAxios.post(`${ENTREGAS_URL}/entrega-vehiculo-maestro/dias-traslado`, data, config);
}

export function editDiasTraslado(values, lugar) {
  const config = {
    headers: {
      idUsuario: IDUSUARIO,
    },
  };

  const data = {
    canDias: values.canDias,
    codSucuDest: values.sucEntrega,
    codSucuOrig: values.sucDespacho,
    codFamilia:values.familia,
    indInactivo: values.indInactivo ? 'N' : 'S',
  };

  return customAxios.put(`${ENTREGAS_URL}/entrega-vehiculo-maestro/dias-traslado/${lugar}`, data, config);
}

export function createUbiPedido(values) {
  const config = {
    headers: {
      idUsuario: IDUSUARIO,
    },
  };

  const data = {
    codProvCarro: values.provCarrocero,
    codSucursal: values.sucursal,
    // codWerksSap: values.,
    desUbicaPedido: values.desUbiPed,
    indCarrocero: values.indCarrocero ? 'S' : 'N',
    indInactivo: 'N',
    indInventario: values.indInventario ? 'S' : 'N',
    codFilial:values.filial,
  };

  return customAxios.post(`${ENTREGAS_URL}/entrega-vehiculo-maestro/ubica-pedido`, data, config);
}

export function editUbiPedido(values, lugar) {
  
  const config ={
    headers:{
      idUsuario:IDUSUARIO
    }
  }

  const data = {
    codProvCarro: values.provCarrocero,
    codSucursal: values.sucursal,
    // codWerksSap: values.,
    desUbicaPedido: values.desUbiPed,
    indCarrocero: values.indCarrocero ? 'S' : 'N',
    indInactivo: values.indInactivo ? 'N' : 'S',
    indInventario: values.indInventario ? 'S' : 'N',
    codFilial:values.filial,
  };

  return customAxios.put(`${ENTREGAS_URL}/entrega-vehiculo-maestro/ubica-pedido/${lugar}`, data, config);
}


export function createFilial(values) {
  const config = {
    headers: {
      idUsuario: IDUSUARIO,
    },
  };

  const data = {
    codFilial: values.codFilial,
    indInactivo: 'N',
    indTipoFilial: values.codTipoFilial,
  };

  return customAxios.post(`${ENTREGAS_URL}/entrega-vehiculo-maestro/tipos-filial`, data, config);
}


export function editFilial(values) {
  const config = {
    headers: {
      idUsuario: IDUSUARIO,
    },
  };

  const data = {
    codFilial: values.codFilial,
    indInactivo: values.indInactivo ? 'N' : 'S',
    indTipoFilial: values.codTipoFilial,
  };

  return customAxios.put(`${ENTREGAS_URL}/entrega-vehiculo-maestro/tipos-filial`, data, config);
}


export function createCapacidades(values) {
  console.log(values);
  const config = {
    headers: {
      idUsuario: IDUSUARIO,
    },
  };

  const data = {
    canUnidAdic: values.adicionalFormulario,
    codFamiliaVeh: values.familiaFormulario,
    codFilial: values.filialFormulario,
    fecExceAdic: moment(values.fechaCapacidad).format('DD/MM/YYYY'),
    indTipoCapa: values.capacidadFormulario,
  };

  return customAxios.post(`${ENTREGAS_URL}/entrega-vehiculo-maestro/ampliacion-capacidades`, data, config);
}

export function editCapacidades(values) {

  const config = {
    headers: {
      idUsuario: IDUSUARIO,
    },
  };

  const data = {
    codConfUnidAdic: values.registroSelected,
    canUnidAdic: values.adicionalFormulario,
    codFamiliaVeh: values.familiaFormulario,
    codFilial: values.filialFormulario,
    fecExceAdic: moment(values.fechaCapacidad).format('DD/MM/YYYY'),
    indInactivo: !values.indInactivo ? 'S' : 'N',
    indTipoCapa: values.capacidadFormulario,
  };

  return customAxios.put(`${ENTREGAS_URL}/entrega-vehiculo-maestro/ampliacion-capacidades/${values.registroSelected}`, data, config);
}




// WEBPACK FOOTER //
// ./src/utils/mantenimientoEntrega.js